import { Container, Typography, Box, Button, Link } from '@mui/material';
import { getImageUrl } from '../../utils';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SafetyDividerIcon from '@mui/icons-material/SafetyDivider';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoIcon from '@mui/icons-material/Info';

const Schedule = () => (
  <Box
    sx={{
      background: 'linear-gradient(to bottom, #ffffff, #fdfdfd)',
      backdropFilter: 'blur(8px)',
      py: { xs: 6, md: 10 },
    }}
  >
    <Container maxWidth="lg">
      <Typography
        variant="h3"
        align="center"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '2rem', md: '2.75rem' },
          mb: 4,
          color: '#1e1e1e',
        }}
      >
        Schema
      </Typography>

      {/* Sock Info + Image */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
          mb: 6,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            maxWidth: '400px',
            fontSize: '1.1rem',
            color: '#444',
            textAlign: 'center',
            lineHeight: 1.7,
          }}
        >
          Observera att alla deltagare måste bära strumpor under klasserna. <br /><br />
          Vi säljer strumpor i olika stilar och prisklasser.
        </Typography>
        <Box
          component="img"
          src={getImageUrl('new-about2.png')}
          alt="Socks"
          sx={{
            width: '100%',
            maxWidth: '200px',
            borderRadius: '1rem',
            boxShadow: '0 10px 24px rgba(0,0,0,0.08)',
          }}
        />
      </Box>

      {/* CTA Button */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
        <Button
          href="/sidepages/klasses"
          sx={{
            background: 'linear-gradient(135deg, #00b5bf, #429398)',
            color: '#fff',
            px: 4,
            py: 1.25,
            fontSize: '1rem',
            fontWeight: 600,
            borderRadius: '999px',
            textTransform: 'none',
            boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
             '&:hover': {
                      transform: 'translateY(-2px)',
                      background: 'linear-gradient(135deg, #007C85, #357f87)',
                    },
          }}
        >
          Våra Klasser
        </Button>
      </Box>

      {/* Iframe Schedule */}
      <Box
        sx={{
          maxWidth: '1000px',
          height: '52rem',
          margin: '0 auto',
          borderRadius: '1rem',
          overflow: 'hidden',
          boxShadow: '0 12px 32px rgba(0,0,0,0.08)',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <iframe
          id="wondr-2"
          src="https://PILATESHOGANAS.wondr.se/schema/"
          width="100%"
          height="100%"
          style={{
            border: 'none',
            width: '100%',
            height: '100%',
          }}
          title="Wondr Booking"
        ></iframe>
      </Box>

      {/* Information with Icons */}
      <Box
        sx={{
          mt: 6,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          maxWidth: '900px',
          mx: 'auto',
          px: { xs: 2, md: 0 },
        }}
      >
        {[
          {
            icon: <EventAvailableIcon sx={{ color: '#00b5bf' }} />,
            text: 'Vi förbehåller oss rätten att ställa in klasser vid för få deltagare.',
          },
          {
            icon: <SafetyDividerIcon sx={{ color: '#00b5bf' }} />,
            text: 'Reformer-klasser är för dem som gått intro Reformer eller tränar PT och har säkerhetskunskap.',
          },
          {
            icon: <HelpOutlineIcon sx={{ color: '#00b5bf' }} />,
            text: 'Är du osäker på vilken klass du ska välja? Kolla klassbeskrivningen eller prata med din instruktör.',
          },
        ].map(({ icon, text }, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center' }}>
            {icon}
            <Typography
              variant="body2"
              sx={{
                fontSize: '1rem',
                fontStyle: 'italic',
                ml: 1,
                color: '#444',
              }}
            >
              {text}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Info Link */}
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Link
          href="/sidepages/bra-att-veta"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#00b5bf',
            fontWeight: 600,
            fontSize: '1rem',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          <InfoIcon sx={{ mr: 1 }} />
          Mer info som är bra för dig att veta: klicka här
        </Link>
      </Box>
    </Container>
  </Box>
);

export default Schedule;
